import { render, staticRenderFns } from "./producer-brand-list.vue?vue&type=template&id=31c5dab0&"
import script from "./producer-brand-list.vue?vue&type=script&lang=js&"
export * from "./producer-brand-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports